<template>
  <div class="dashboard-page">
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="grid-content">
          <div class="dashboard-stat" style="background-color: rgb(245,186,78);">
            <div class="visual"><i class="fa fa-diamond text-white"></i></div>
            <div class="details">
              <div class="number">
                <div class="desc">项目总数</div>
                <span class="count">{{projectNum}}个</span>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content">
          <div class="dashboard-stat" style="background-color:rgb(94,180,241)">
            <div class="visual"><i class="fa fa-credit-card text-white"></i></div>
            <div class="details">
              <div class="number">
                <div class="desc">测评总人数</div>
                <span class="count">{{evUserNum}}人</span>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="dashboard-stat" style="background-color: rgb(245,133,99);">
            <div class="visual"><i class="fa fa-send text-white"></i></div>
            <div class="details">
              <div class="number">
                <div class="desc">我的方案</div>
                <span class="count">{{schemeNum}}套</span>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="dashboard-stat" style="background-color: rgb(137,118,241)">
            <div class="visual"><i class="fa fa-volume-control-phone text-white"></i></div>
            <div class="details">
              <div class="number">
                <div class="desc">套餐剩余</div>
                <span class="count">{{surplusNum}}套</span>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="box margin-bottom-15">
      <div class="box-header">
        <h3 class="box-title"><i class="fa fa-th-large"></i> 最近项目</h3>
        <div class="box-tools" v-if="projectList">
          <el-button type="primary" size="small" class="pull-right" @click="toMore('job')" round> 查看更多</el-button>
        </div>
      </div>
      <div class="box-body">
        <el-table :header-cell-style="{ background: '#eef1f6', color: '#606266' }" :data="projectList" border :stripe="true" style="width: 100%">
          <template slot="empty">
            <div class="no-data">暂无数据！</div>
          </template>
          <el-table-column label="序号" align="center" width="60">
            <template slot-scope="scope">
              <span>{{scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column label="项目名称">
            <template slot-scope="scope">
              <el-button size="medium" type="text" @click="toDetail(scope.row)">{{scope.row.name}}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="目标企业" width="300" prop="unit"></el-table-column>
          <el-table-column label="方案名称" width="300" prop="schemeName"></el-table-column>
          <el-table-column label="已测人数" width="120" prop="num"></el-table-column>
          <el-table-column label="状态" width="120">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status==0" type="" effect="plain" size="small">未开始</el-tag>
              <el-tag v-if="scope.row.status==1" type="success" effect="plain" size="small">进行中</el-tag>
              <el-tag v-if="scope.row.status==2" type="danger" effect="plain" size="small">已结束</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="结束时间" width="120">
            <template slot-scope="scope">
              <span>{{formatDate(scope.row.endTime)}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="box margin-bottom-15">
      <div class="box-header">
        <i class="fa fa-bars"></i>
        <h3 class="box-title">测评人数</h3>
      </div>
      <div class="box-body">
        <ve-histogram :data="monthData" :extend="extend"></ve-histogram>
      </div>
    </div>
  </div>
</template>

<script>
  import {getProjectNum, fetchData,get} from '@/api/evaluation/project'
  import {getEvUserNum, countByMouth} from '@/api/manage/company'
  import {getSchemeSurplus, getSchemeCount} from '@/api/evaluation/scheme'
  import {parseTime} from '@/utils/index'
  import StandardList from '@/views/evaluation/Standard.vue'
  import { mapGetters } from 'vuex'


  export default {
    name: 'main-content',
    computed: {
      ...mapGetters(['user', 'company']),
    },
    data() {
      return {
        info: {
          schemeId: null,
          schemeType: 'standard',
          scheme:{}
        },
        routerInfo:{},
        projectNum: 0,//  我的项目总数
        evUserNum: 0,//项目测评总人数
        schemeNum: 0,//我的方案个数
        surplusNum: 0,//套餐剩余套数
        projectList: [],
        monthData: {
          columns: ['time', 'e','项目个数'],
          rows: [],
        },
        extend: {
          xAxis: {
            axisLabel: {rotate: 10}
          },
          series:{
            itemStyle: {
              normal: {
                label: {
                  show: true,		//开启显示
                  position: 'top',	//在上方显示
                  textStyle: {	    //数值样式
                    color: 'black',
                    fontSize: 16,
                  },
                }
              },
            },
            barWidth : 25,//柱图宽度
          }
        },
      }
    },
    components: {StandardList},
    created() {
      this.getProjectNum()
      this.getEvUserNum()
      this.getSchemeSurplus()
      this.getSchemeCount()
      this.getProjectList()
      this.countByMouth()
    },
    methods: {
      formatDate(time) {
        return parseTime(time, "{y}-{m}-{d}")
      },
      getProjectList() {
        fetchData(this.user.id, { pageSize:8,param:{type:1} }).then(resp => {
          this.projectList = resp.data.result.records
        })
      },
      getProjectNum() {
        getProjectNum().then(resp => {
          this.projectNum = resp.data.result
        })
      },
      getEvUserNum() {
        getEvUserNum(this.company.id).then(resp => {
          this.evUserNum = resp.data.result
        })
      },
      getSchemeSurplus() {
        getSchemeSurplus(this.company.id).then(resp => {
          this.surplusNum = resp.data.result
        })
      },
      getSchemeCount() {
        getSchemeCount(this.company.id).then(resp => {
          this.schemeNum = resp.data.result
        })
      },
      countByMouth() {
        countByMouth(this.company.id).then(resp => {
          this.monthData.rows = resp.data.result
        })
      },
      toDetail(info) {
        if (info.schemeType == 'standard'){
          this.$router.push({ path: `/evaluation/project/standard/${info.id}`})
        }else{
          this.$router.push({ path: `/evaluation/project/person/${info.id}` })
        }
      },
      toMore() {
        this.$router.push({path: '/evaluation/project/list'})
      },
    }
  }
</script>

<style lang="scss">
  .dashboard-page {
    .el-drawer:focus {
      outline: none !important;
    }

    .drawer-bar {
      box-sizing: border-box;
      padding: 15px;
      height: calc(100% - 70px);
    }

    .el-tabs__nav {
      > div {
        box-shadow: none !important;
      }
    }
  }
</style>
<style lang="scss" scoped>
  .breadcrumb-bar {
    border-bottom: 1px solid #ccc;
    background-color: #fff;
    padding-left: 20px;

    .el-breadcrumb {
      font-size: 12px;
      padding: 15px 0;
    }
  }

  .dashboard-stat {
    border: 1px solid rgba(228, 228, 228, 1);
    margin-bottom: 25px;
    overflow: hidden;
    border-radius: 4px;
    background-color: #fff;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:after {
      content: ' ';
      display: table;
      clear: both;
    }

    .visual {
      font-size: 58px;
      color: #1890ff;
      float: left;
      width: 30%;
      overflow: hidden;
      min-height: 50px;
      text-align: center;
    }

    .details {
      float: right;
      flex: 1;

      .number {
        margin-top: 0px;
        text-align: right;
      }

      .desc {
        font-size: 16px;
        font-weight: 700;
      }

      .count {
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
</style>
